import {
  Card,
  CardHeader,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Scrollbar } from '../../../../components/atoms/scrollbar';
import { Destination } from '../../api/types/visits';

interface VisitDestinationProps {
  mainDestination: Destination;
  additionalDestinations: Destination[];
}

export const VisitDestination: FC<VisitDestinationProps> = ({
  additionalDestinations,
  mainDestination,
}) => {
  const { t } = useTranslation(['visit']);

  const columns = [
    {
      id: 'name',
      column: t('visit:destination.name'),
    },
    {
      id: 'floor',
      column: t('visit:destination.floor'),
    },

    {
      id: 'description',
      column: t('visit:destination.description'),
    },
  ];

  const [combinedDestinations, setCombinedDestinations] = useState<Destination[]>([]);

  useEffect(() => {
    if (additionalDestinations?.length > 0) {
      setCombinedDestinations([...additionalDestinations, mainDestination]);
    } else {
      setCombinedDestinations([mainDestination]);
    }
  }, [additionalDestinations, mainDestination]);

  return (
    <Card variant="outlined">
      <CardHeader title={t('visit:destination.cardTitle')} />
      <Divider />
      <Scrollbar>
        <Table>
          <TableHead>
            <TableRow>
              {columns.map(column => (
                <TableCell key={column.id}>{column.column}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {combinedDestinations.map(destination => (
              <TableRow key={destination.id}>
                <TableCell>{destination.name}</TableCell>
                <TableCell>{destination.floor.toString()}</TableCell>
                <TableCell>{destination.description ? destination.description : ''}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Scrollbar>
    </Card>
  );
};
